import { useProcessingNegotiationBadgeCountQuery } from 'src/entities/processing';
import { useSoundOnUnreadIncrease } from 'src/shared/notification';
import { useProcessingRealtime } from './useProcessingRealtime';

export const useProcessingNotifications = (): void => {
  const { count, isReady } = useProcessingNegotiationBadgeCountQuery();

  useProcessingRealtime();
  useSoundOnUnreadIncrease(count, isReady);
};
